import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { wacToken } from "@/libraries/design/foundations";

import { GlobalNavProductRecommendationsSimple } from "./global-nav-product-recommendations/components/global-nav-product-recommendations-simplified";
import {
    ProductGrid,
    ProductItem,
    useProductData,
    Product,
    ProductCategory
} from "./product-subnav";

export const ProductFeaturedCollectionSubnav = ({
    isMobile
}: {
    isMobile?: boolean;
}) => {
    const intl = useIntl();
    const { productsByTag } = useProductData();

    return (
        <UFOSegment name="collections-container-with-rovo">
            <ProductGrid
                isRovoTitle={true}
                header={
                    <>
                        <GlobalNavProductRecommendationsSimple
                            isMobile={isMobile}
                        />
                        <h2 className="collections-four" css={CollectionsTitle}>
                            {intl.formatMessage({
                                id: "GlobalNav.collections.featured.atlassiancollections.title",
                                defaultMessage: "Atlassian Collections"
                            })}
                        </h2>
                    </>
                }
            >
                {productsByTag[ProductCategory.Featured].map(
                    (product: Product) => (
                        <ProductItem key={product.id} {...product} />
                    )
                )}
            </ProductGrid>
        </UFOSegment>
    );
};

const CollectionsTitle = css({
    [`&.collections-four`]: {
        fontSize: "0.75rem",
        margin: 0,
        textTransform: "uppercase",
        color: wacToken("color.primary.black"),
        fontWeight: 400,
        fontFamily:
            "'Charlie Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif",
        lineHeight: "20px"
    }
});
